import { TableHead, TableRow, TableHeaderText, TableHeadCell } from '@pocketlaw/tetris';
import { TITLE_CELL_WIDTH } from '../consts';
export function SearchResultsTableHead(props) {
    const { columnConfigs } = props;
    return (<TableHead>
      <TableRow>
        {columnConfigs.map(column => {
            if (column.label && column.id) {
                return (<TableHeadCell key={column.id} id={column.id} maxWidth={column.id === 'title' ? TITLE_CELL_WIDTH : undefined} colSpan={column.colSpan} stickyColumn={column.stickyColumn}>
                <TableHeaderText sortId={column.sortId}>{column.label || ''}</TableHeaderText>
              </TableHeadCell>);
            }
            return null;
        })}
      </TableRow>
    </TableHead>);
}
